// material-ui
import { useContext, useEffect } from "react";
import Loader from "ui-component/Loader";
import { commonService } from "forms/helpers/common.service";
import popupItems from "utils/popup.constant";
import {
  setMenuItemsRedux,
  setPopupItemsRedux,
  setSubMenuItemsRedux,
  setUserRedux,
} from "store/slice/user.slice";
import menuItems from "container/layout/menu-items";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "store/store";
import defaultRole from "constant/config.role";
import { KeycloackContext } from "./keycloak/useKeyCloak";
import {
  accidentreport,
  Documents,
  telematics,
  serviceagent,
  drivers,
  fleet,
  Mail,
  serviceprovider,
  vehicle,
  vehicleowner,
  vehiclepermit,
} from "container/layout/menu-items/agent";
import { RolesName } from "constant/helpText";
import { IUser } from "interfaces/common.interface";
import { MenuUrl } from "utils/constant.utils";
// assets

// ================================|| AUTH3 - LOGIN ||================================ //

const Login = () => {
  /* keycloak import */
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const getUserDetails = async () => {
    try {
      const user: any = await commonService.getServices(
        "/v2/profile/my_profile",
        false
      );
      try {
        if (user?.data) {
          const userData = user.data.data;
          console.log("first", userData.user?.user_badges[0]);
          let role: any = [];
          let badges = [];
          if (userData.user?.user_badges.length) {
            badges = userData.user?.user_badges.map((x: any) => {
              const isAdmin = userData.user[RolesName[x.badge?.name]]?.is_admin;
              return { ...x.badge, status: x.status, isAdmin };
            });
          }
          badges = badges.filter((x: any) => x.status === "Approved");
          if (badges.length) {
            badges.map((b: any) => role.push(b.name));
          } else {
            window.location.href =
              "https://ehub-dc2.blockchaincloudapps.com/login";
            return;
          }
          let userDetails: any = userData;
          let created_by_user: any;
          const created_by = {
            company_name: created_by_user?.company_name,
            id: userDetails?.created_by?.id,
            userDetailID: created_by_user?.id,
            firstname: created_by_user?.firstname,
            lastname: created_by_user?.lastname,
            email: created_by_user?.email,
          };
          const setUserData: IUser = {
            email: userData?.email,
            id: userData?.id,
            userDetailID: userDetails?.id,
            firstname: userDetails.firstname,
            lastname: userDetails.lastname,
            role: role,
            company_name: userDetails?.company_name,
            mobile_number:
              userDetails?.country_code + userDetails?.mobile_number,
            mobile_verified: userDetails?.mobile_verified,
            email_verified: userDetails?.email_verified,
            entra_verified: userDetails?.entra_verified,
            created_by,
            badges,
            userDetails: userData.user,
          };
          localStorage.setItem("at-dl-user", JSON.stringify(setUserData));
          dispatch(setUserRedux(setUserData));
          let menus: any = [];

          let popupItem: any = popupItems.admin;
          if (userData.user?.is_admin) {
            menus = menuItems.admin;
            popupItem = popupItems.admin;
            dispatch(setMenuItemsRedux(menus));
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          } else if (
            badges?.length === 1 &&
            badges.some((x: any) => x.name === defaultRole.profile)
          ) {
            menus = menuItems.profile;
            popupItem = popupItems.admin;
            dispatch(setMenuItemsRedux(menus));
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          } else if (
            badges.some(
              (x: any) =>
                x.name === defaultRole.adminuser && x.status === "Approved"
            )
          ) {
            menus = menuItems.employee;
            popupItem = popupItems.admin;
            handleRoleMenu(menus, badges, userData, true);
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          } else if (
            badges.some(
              (x: any) =>
                x.name === defaultRole.agent &&
                x.status === "Approved" &&
                x?.isAdmin
            )
          ) {
            menus = menuItems.ServiceRep;
            popupItem = popupItems.admin;
            handleRoleMenu(menus, badges, userData);
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          } else if (
            badges.some(
              (x: any) =>
                x.name === defaultRole.driver && x.status === "Approved"
            )
          ) {
            menus = menuItems.driver;
            popupItem = popupItems.agent;
            handleRoleMenu(menus, badges, userData);
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          } else {
            menus = menuItems.otheruser;
            popupItem = popupItems.agent;
            handleRoleMenu(menus, badges, userData);
            dispatch(setSubMenuItemsRedux(menus[0]?.children[2]?.children));
          }
          dispatch(setPopupItemsRedux(popupItem));
          if (userData.user?.is_admin)
            navigate(`/${defaultRole.admin}/portal/dashboard`);
        }
      } catch (e) {
        console.error("error----", e);
      }
    } catch (e) {
      console.error("error----", e);
    }
  };

  const handleRoleMenu = (
    menus: any,
    badges: any,
    userData: any,
    useradmin: boolean = false
  ) => {
    let children = menus[0]?.children[3]?.children;
    if (useradmin) children = [];
    if (
      badges.some(
        (x: any) => x.name === defaultRole.agent && x.status === "Approved"
      ) &&
      userData.user?.agent_user?.is_admin
    ) {
      children = [];
      children.push(serviceagent);
    }
    if (
      badges.some(
        (x: any) => x.name === defaultRole.driver && x.status === "Approved"
      )
    )
      children.push(drivers);
    if (
      badges.some(
        (x: any) =>
          x.name === defaultRole.fleet_operator &&
          x.status === "Approved" &&
          userData.user?.fleet_user?.is_admin
      )
    )
      children.push(fleet);
    if (
      badges.some(
        (x: any) =>
          x.name === defaultRole.vehicleowner &&
          x.status === "Approved" &&
          userData.user?.user_vehicle_owner?.is_admin
      )
    )
      children.push(vehicleowner);
    if (
      badges.some(
        (x: any) =>
          x.name === defaultRole.service_provider &&
          x.status === "Approved" &&
          userData.user?.service_provider_user?.is_admin
      )
    )
      children.push(serviceprovider);
    let addedMenu: any = [];
    if (!useradmin) {
      if (
        badges.some(
          (x: any) =>
            (x.name === defaultRole.agent || x.name === defaultRole.driver) &&
            x.status === "Approved"
        )
      )
        addedMenu = [
          vehicle,
          vehiclepermit,
          telematics,
          Documents,
          accidentreport,
        ];
      else if (
        badges.some(
          (x: any) =>
            (x.name === defaultRole.fleet_operator ||
              x.name === defaultRole.vehicleowner) &&
            x.status === "Approved"
        )
      ) {
        addedMenu = [vehicle, vehiclepermit, telematics];
      }
    } else addedMenu = [vehicle, vehiclepermit, telematics];
    menus[0].children[3]["children"] = [...children, ...addedMenu];
    menus[0].children[3]["url"] = menus[0].children[3]["children"][0]?.url;
    dispatch(setMenuItemsRedux(menus));
    if (searchParams.get("url")) {
      const parentID = MenuUrl[searchParams.get("url") || "member_portal"];
      if (!parentID) {
        navigate(`/${defaultRole.profile}/portal/dashboard`);
        return;
      } else {
        const item = menus[0].find((item: any) => item.id === parentID);
        if (!item?.children?.length)
          navigate(`/${defaultRole.profile}/portal/dashboard`);
        let navURL = item.children[0]?.url;
        navigate(navURL);
      }
    } else {
      navigate(`/${defaultRole.profile}/portal/dashboard`);
    }
  };

  // keycloak sso login start
  const { keycloak, authenticated } = useContext(KeycloackContext);
  useEffect(() => {
    if (keycloak) {
      if (keycloak?.authenticated) {
        console.log("after auth", keycloak?.token);
        localStorage.setItem("at-dl-token", keycloak.token);
        getUserDetails();
      } else {
        keycloak.login();
      }
    }
  }, [keycloak]);
  return <>{<Loader />}</>;
};

export default Login;
